module.exports = __webpack_public_path__ + "img/icon_investmezzanine_process_03.3a0de2f9.svg";